module.exports = __webpack_public_path__ + "static/img/ikonaBrudnopis-OFF.011755de.png";